<template>
  <footer class="footer-brand">
    <div class="footer-content">
      <span class="footer-bold">MY EVENTO</span>
      <span class="footer-script">Digital</span>
      <p class="footer-tagline">Invitaciones digitales que emocionan desde el primer clic</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterBrand',
};
</script>

<style scoped>
.footer-brand {
  width: 100%;
  padding: 20px 0;
  text-align: center;
  background-color: #fdfdfd;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 -5px 15px rgba(0, 0, 0, 0.03);
  margin-top: 60px;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.2;
}

.footer-bold {
  font-family: 'Playfair Display', serif;
  font-size: 14px;
  color: #3f3f3f;
  letter-spacing: 0.5px;
}

.footer-script {
  font-family: 'serenety', cursive;
  font-size: 18px;
  color: #b49d90;
  margin-top: 2px;
}

.footer-tagline {
  font-family: 'Poppins', sans-serif;
  font-size: 11px;
  color: #6c6c6c;
  margin-top: 6px;
}

@media (max-width: 480px) {
  .footer-bold {
    font-size: 12px;
  }

  .footer-script {
    font-size: 16px;
  }

  .footer-tagline {
    font-size: 10px;
  }
}

</style>